<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!verificarPermissao('PERM_PACOTE_CENTRAL_CLIENTE')">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="verificarPermissao('PERM_PACOTE_CENTRAL_CLIENTE')">
            <form>
                <div class="formgroup">
                    <div class="flex justify-content-center" *ngIf="loading">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div *ngIf="messagemVisivel" class="w-auto mb-5">
                        <p-messages
                            [(value)]="messages"
                            [enableService]="false"
                            [closable]="true"
                        ></p-messages>
                    </div>
                    <div
                        class="p-fluid p-formgrid grid pt-3 px-3"
                        *ngIf="orcamento && !isExibirSpinnerPrincipal()"
                    >
                        <div class="col-12 card-simple">
                            <div class="grid justify-content-between">
                                <div class="field col-12 md:col-6 xl:col-2">
                                    <label class="label-sem-borda-bottom">Nª Pacote</label>
                                    <label class="form-control-sem-borda">
                                        <i class="pi pi-objects-column mr-1"></i>
                                        {{ orcamento.numeroOrcamento }}
                                    </label>
                                </div>

                                <div class="field col-12 md:col-6 xl:col-2">
                                    <label class="label-sem-borda-bottom">Cliente</label>
                                    <label class="form-control-sem-borda">
                                        <i class="pi pi-user mr-1"></i>
                                        {{ orcamento.interessado?.nome }}
                                    </label>
                                </div>
                                <div class="field col-12 md:col-6 xl:col-2">
                                    <label class="label-sem-borda-bottom">Data</label>
                                    <label class="form-control-sem-borda">
                                        <i class="pi pi-calendar mr-1"></i>
                                        {{ orcamento.dataOrcamento | date: "dd/MM/yyyy" }}
                                    </label>
                                </div>
                                <div class="field col-12 md:col-6 xl:col-2">
                                    <label class="label-sem-borda-bottom">Valor Pago</label>
                                    <label class="form-control-sem-borda">
                                        <i class="pi pi-money-bill mr-1"></i>
                                        {{ orcamento.valorPago ?? 0 | currency: "BRL" }}
                                    </label>
                                </div>
                                <div class="field col-12 md:col-6 xl:col-2">
                                    <label class="label-sem-borda-bottom">Situação</label>
                                    <label class="form-control-sem-borda">
                                        <span
                                            class="product-badge bg-gray-600 admihair-text-white"
                                            *ngIf="orcamento.status === 'RESGATADO_CREDITO_CLIENTE'"
                                            pTooltip="Resgate com geração de crédito na conta do Cliente"
                                        >
                                            RESGATADO SALDO
                                        </span>
                                        <span
                                            *ngIf="orcamento.status === 'RESGATADO_PAGO'"
                                            class="product-badge bg-gray-600 admihair-text-white"
                                            pTooltip="Resgatado com pagamento ao Cliente"
                                        >
                                            RESGATADO PAGO
                                        </span>
                                        <span
                                            *ngIf="orcamento.status === 'PAGO'"
                                            class="product-badge bg-blue-600 admihair-text-white"
                                        >
                                            {{ orcamento.status }}
                                        </span>
                                        <span
                                            *ngIf="orcamento.status === 'FINALIZADO'"
                                            class="product-badge bg-green-600 admihair-text-white"
                                        >
                                            {{ orcamento.status }}
                                        </span>
                                        <span
                                            *ngIf="orcamento.status === 'ABERTO'"
                                            class="product-badge bg-teal-600 admihair-text-white"
                                        >
                                            {{ orcamento.status }}
                                        </span>
                                        <span
                                            *ngIf="orcamento.status === 'VENCIDO'"
                                            class="product-badge bg-red-600 admihair-text-white"
                                        >
                                            {{ orcamento.status }}
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div
                            class="w-full flex justify-content-end mt-2"
                            *ngIf="orcamento.tipo === 'PACOTE' && orcamento.status === 'PAGO'"
                        ></div>

                        <div class="w-full mt-5">
                            <div>
                                <h5>Itens</h5>
                            </div>
                            <p-table
                                #dt1
                                [value]="itensOrcamento"
                                dataKey="id"
                                [rows]="10"
                                [rowHover]="true"
                                [paginator]="false"
                                responsiveLayout="stack"
                                styleClass=" p-datatable-sm"
                            >
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Serviço</th>
                                        <th>Quantidade</th>
                                        <th>Entregue</th>
                                        <th>Saldo</th>
                                        <th>Saldo(R$)</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>
                                            <label>{{ item.nomeItem }}</label>
                                        </td>
                                        <td>
                                            <label>{{ item.quantidadeProposta }}</label>
                                        </td>
                                        <td>
                                            <label>{{ item.quantidadeEntregue }}</label>
                                        </td>

                                        <td>
                                            <label>
                                                {{
                                                    item.quantidadeProposta -
                                                        item.quantidadeEntregue
                                                }}
                                            </label>
                                        </td>
                                        <td>
                                            {{ calcularValorAResgatar(item) | currency: "BRL" }}
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="summary">
                                    <div
                                        class="flex flex-column align-items-end justify-content-end"
                                    >
                                        <div>
                                            Saldo total:
                                            {{ orcamento.totalResgatar | currency: "BRL" }}
                                        </div>
                                        <div *ngIf="orcamento.status === 'PAGO'">
                                            Valor a resgatar:
                                            {{ orcamento.totalResgatar | currency: "BRL" }}
                                        </div>
                                        <div
                                            *ngIf="
                                                orcamento.status === 'RESGATADO_CREDITO_CLIENTE' ||
                                                orcamento.status === 'RESGATADO_PAGO'
                                            "
                                        >
                                            Valor resgatado:
                                            {{ orcamento.totalResgatar | currency: "BRL" }}
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="7">Nenhum registro cadastrado.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
